import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

import { ArchivalAidMetadata } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import { OrderCtx } from 'components/order-ctx/order-ctx';
import { AuthCtx } from 'components/auth/auth-ctx';
import { OrderRemoveConfirmationDialog } from 'modules/portfolio-order/order-remove-confirmation-dialog';
import { getArchivalAidOrderDetails } from 'modules/portfolio-order/order-utils';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function ArchivalAidOrder({ item }: GridActionButtonComponent) {
  const classes = useStyles();
  const { userInfo, userSheet } = useContext(AuthCtx);
  const { archivalUnits, handleAisOrder } = useContext(OrderCtx);
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const withUnits = !!archivalUnits?.length;

  const archivalAidMetadata = item as ArchivalAidMetadata;

  const newOrderValues = getArchivalAidOrderDetails(
    archivalAidMetadata,
    userInfo!,
    userSheet
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    handleClose();
    handleAisOrder?.(newOrderValues);
    history.push('/portfolio/vytvoreni-objednavky');
  };

  return userInfo?.aisAuthenticated ? (
    <>
      <Button
        component="span"
        variant="outlined"
        color="primary"
        className={classes.navigationButton}
        onClick={withUnits ? handleOpen : handleConfirm}
      >
        Vytvořit objednávku
      </Button>
      <OrderRemoveConfirmationDialog
        open={open}
        handleConfirm={handleConfirm}
        handleClose={handleClose}
      />
    </>
  ) : (
    <></>
  );
}
